module.exports = __webpack_public_path__ + "static/media/user-profile-avatar.8cb36f4d.png";